//#region Imports
import Modal from 'react-bootstrap/Modal';
import { DateTimePicker, LocalizationProvider } from '@mui/x-date-pickers-pro';
import { AdapterMoment } from '@mui/x-date-pickers-pro/AdapterMoment';
import moment from 'moment';

function ModalRecurrVisit(props) {
  const doubleColumns = props.dates.length >= 6;

  // Styles for form container
  const formStyle = {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '10px',
  };

  // Conditional DateTimePicker style
  const dateTimePickerStyle = {
    width: doubleColumns ? 'calc(50% - 10px)' : '100%',
    marginBottom: '3%',
  };

  return (
    <>
      <LocalizationProvider
        dateAdapter={AdapterMoment}
        adapterLocale={moment.locale()}
      >
        <Modal
          {...props}
          size="xs"
          aria-labelledby="contained-modal-title-vcenter"
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title id="contained-modal-title-vcenter">
              Recurrencia personalizada
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <form id="per-recurr-form" style={doubleColumns ? formStyle : {}}>
              {props.dates.map((date, index) => (
                <DateTimePicker
                  key={index}
                  label={`Fecha de compromiso ${index + 2}`} // Empieza desde 2
                  sx={dateTimePickerStyle}
                  value={moment(date)}
                  onChange={(newDate) => {
                    props.onChange(index, newDate);
                  }}
                  slotProps={{
                    textField: {
                      required: true,
                    },
                  }}
                />
              ))}
            </form>
          </Modal.Body>
          <Modal.Footer>
            <button
              className="save-modal-button"
              onClick={() => props.onHide()}
            >
              Confirmar
            </button>
          </Modal.Footer>
        </Modal>
      </LocalizationProvider>
    </>
  );
}

export default ModalRecurrVisit;
